var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.info.type,attrs:{"module-item":""},domProps:{"innerHTML":_vm._s(_vm.info.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }